export const NEXUS_JOURNEY_INTEGRATIONS_TABLE = [
  {
    Application: '**GitHub**',
    Status: '**✅ Connected**',
    'What Was Done': 'Read `requirement.md` from *company website* repo',
    'How It Helps': 'Source of truth for the development plan',
  },
  {
    Application: '**Salesforce**',
    Status: '**✅ Connected**',
    'What Was Done': 'OAuth2 wired, lead + opportunity sync, demo-user RFQ trigger',
    'How It Helps': 'CRM pipeline for procurement leads and workflow automation',
  },
  {
    Application: '**HubSpot**',
    Status: '**✅ Connected**',
    'What Was Done': 'SRM objects synced, supplier pipeline and engagement scoring',
    'How It Helps': 'Supplier relationship management alongside CRM deals',
  },
  {
    Application: '**Procurify**',
    Status: '**✅ Connected**',
    'What Was Done': 'Purchase request API, approval routing, budget codes mapped',
    'How It Helps': 'Procurement management from RFQ through approved spend',
  },
  {
    Application: '**Stripe**',
    Status: '**✅ Connected**',
    'What Was Done': 'Payment intent API + webhook listener verified',
    'How It Helps': 'Ready for checkout and billing at launch',
  },
  {
    Application: '**Mailchimp**',
    Status: '**✅ Connected**',
    'What Was Done': 'Audience sync + RFQ nurture journey mapped',
    'How It Helps': 'Trigger emails when demo users submit quotes',
  },
  {
    Application: '**Google Cloud**',
    Status: '**✅ Connected**',
    'What Was Done': '9-phase deployment — Cloud Run, Cloud SQL, Load Balancer, SSL',
    'How It Helps': 'Production hosting at `app.nexusb2b.com`',
  },
]
